import { Award, Medal, Trophy } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface Achievement {
  id: string;
  title: string;
  description: string;
  earned: boolean;
}

interface AchievementBadgesProps {
  achievements: Achievement[];
}

// Helper function to determine which icon to use based on the achievement title
const getAchievementIcon = (title: string) => {
  const lowerTitle = title.toLowerCase();
  if (lowerTitle.includes('perfect') || lowerTitle.includes('mastery')) {
    return Trophy;
  }
  if (lowerTitle.includes('consistency') || lowerTitle.includes('steady')) {
    return Medal;
  }
  return Award;
};

export const AchievementBadges = ({ achievements }: AchievementBadgesProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Achievements</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {achievements.map((achievement) => {
            const IconComponent = getAchievementIcon(achievement.title);
            return (
              <div
                key={achievement.id}
                className={`flex flex-col items-center p-4 rounded-lg border ${
                  achievement.earned
                    ? "border-primary bg-primary/5"
                    : "border-gray-200 opacity-50"
                }`}
              >
                <IconComponent
                  className={`w-8 h-8 mb-2 ${
                    achievement.earned ? "text-orange-400" : "text-gray-400"
                  }`}
                />
                <h3 className="text-sm font-medium text-center mb-1">
                  {achievement.title}
                </h3>
                <p className="text-xs text-center text-muted-foreground">
                  {achievement.description}
                </p>
              </div>
            )}
          )}
        </div>
      </CardContent>
    </Card>
  );
};